<template>
  <div>
    <h5>По четверти</h5>
    <ul class="status">
      <li v-for="(item, key) in parts" :key="key">
        <div>
          <input @change="change(item)" :id="`part-${name}-${key}`"  :name="`part-${name}`"
            :checked="value && item.from_at == value.start &&  item.till_at == value.end" type="radio" />
          <label :for="`part-${name}-${key}`">
            {{ item.position }} - ({{ item.from_at | dateFormat }} - {{ item.till_at | dateFormat }})
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  created() {

  },
  data() {
    return {
      name: 'part'
    };
  },
  computed: {
    parts: {
      get() {

        let parts = [...this.season.parts];

        if (parts && parts.length) {

          parts.push(
            {
              from_at: parts[0]['from_at'],
              till_at: parts[parts.length - 1]['till_at'],
              position: 'all'
            }
          );
        }

        return parts
      }
    }
  },
  props: ["season", "discipline", "value"],
  methods: {
    change(item) {
      this.$emit("input", {
        start: item.from_at,
        end: item.till_at,
      });
    },
  },
  watch: {
    discipline: {
      handler: function (val) {
        this.$emit("input", null);
      },
      deep: true,
      immediate: true,
    },
  }
};
</script>

